<template lang="pug">
  .gvl-home
    v-row.my-0
      v-col.py-0(cols="12")
        h2.mb-3 Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR

        .notice-box Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind.

        p.mb-2 Willkommen auf dem Antragsportal der Gesellschaft zur Verwertung von Leistungsschutzrechten (GVL).
        p.mb-2 Die Corona-Krise hat vielen Künstlern* die Möglichkeiten genommen, in ihrem Berufsfeld Geld zu verdienen: Theater, Kinos und Konzerthallen sind seit mehr als einem Jahr geschlossen. Musik-, Fernseh- und Filmproduktionen können nur stark eingeschränkt stattfinden. Die Bundesbeauftragte für Kultur und Medien hat im Auftrag der Bundesregierung das Programm NEUSTART KULTUR aufgelegt, um die Kulturschaffenden im Land zu unterstützen. Das Stipendienprogramm der Verwertungsgesellschaften fördert in diesem Herbst künstlerische Maßnahmen über einen Zeitraum von vier Monaten.

        p.mt-4.mb-2: i 5000 Euro für künstlerische Maßnahmen
        p.mb-2 Die GVL verteilt die Förderung an freiberufliche oder auf Produktionsdauer beschäftigte Künstler. Der Gesamtumfang beträgt 30 Mio. EUR. Ab August können sich Künstler bei der GVL für ein Stipendium von 5.000 EUR bewerben.

        p.mt-4.mb-2: i Antragstellung
        p.mb-2 Das Stipendienprogramm richtet sich an freiberufliche Künstler, die überwiegend von ihren Einnahmen aus künstlerischer Tätigkeit leben und die durch die Corona-Krise in eine existentielle Notlage geraten sind.
        p.mb-2 Anträge können auf dieser Website online eingereicht werden. Die Stipendien werden in der Reihenfolge der Antragstellung vergeben. Über die Stipendienvergabe entscheidet eine unabhängige Fachjury.
        p.mb-2 Die Antragssteller müssen keine Berechtigten der GVL sein, da die künstlerische Tätigkeit auch anderweitig nachgewiesen werden kann.

        p.mt-4.mb-2: i Geförderte Maßnahmen
        p.mb-2 Gefördert werden künstlerische Projekte wie Darbietungen, Produktionen oder Online-Formate. Die Projekte können sich noch im Entwicklungsstadium befinden, es kann sich um Kooperationen oder um Rechercheprojekte für künftige Produktionen handeln. Das Stipendium unterstützt auch Künstler, die sich neue Techniken und Arbeitsweisen im Rahmen einer Fortbildung aneignen möchten, wenn diese für die Umsetzung eines Entwicklungsvorhabens erforderlich sind.

        p.mt-4.mb-2: i Details in den FAQ
        p.mb-2 Nähere Informationen zur Antragstellung, zum Förderverfahren und zur Abrechnung der Förderung finden Sie in den FAQ. Bitte lesen Sie die Informationen gründlich durch, bevor Sie Ihren Antrag stellen.
        p.mb-2: b Bei weiteren Fragen wenden Sie sich Montag bis Sonntag von 6:00 bis 22:00 Uhr an unsere Hotline unter der Nummer 0202-2515 57305.

        p.mt-4.mb-2: i Informationen zu NEUSTART KULTUR
        p
          | Weitere Informationen der Bundesregierung zu NEUSTART KULTUR finden Sie hier: <br>
          | <a href="https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien/corona-hilfen" target="blank">www.kulturstaatsministerin.de/neustartkultur</a>

        p.small-text.mt-6.mb-2 <sup>*</sup>Aufgrund der besseren Lesbarkeit wird im Text das generische Maskulinum verwendet. Gemeint sind jedoch immer alle Geschlechter (m/w/d).
        p.small-text Die Verteilung der Fördergelder für die anderen Kultur- und Medienbereiche übernehmen verschiedene Organisationen.

    // template(v-if="!isFinished && !isSigned")
      p.text-center.mt-6.mb-2 Hier gelangen Sie mit einem Klick zur Antragstellung
      v-btn.mb-6(block color="primary" @click="onClickAntrag") Zum Antrag

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],
})
export default class Home extends Vue {
  created () {
    this.loadConfig()
  }

  loadConfig () {
    this.$axios
      .get(Urls.GetConfig)
      .then(res => {
        this.$store.dispatch('setDisabledUrl', res.data.antrag_disabled_url)
      })
  }

  onClickAntrag () {
    if (this.disabledUrl) {
      // this.gotoRoute('disabled')
      location.href = this.disabledUrl
    } else {
      this.gotoRoute('inputs')
    }
  }
}
</script>
